export const env = process.env.REACT_APP_ENV;
export const api = process.env.REACT_APP_API_ENDPOINT;
export const isBrowser = typeof window !== 'undefined';
